import { useEffect, useState } from "react";
import { ticketArtKeyFor } from "@/lib/ticketLayout";

function read(): "mobile" | "desktop" {
  return ticketArtKeyFor(window.innerWidth / Math.max(1, window.innerHeight));
}

/**
 * 票幕用哪一版票版（竖版 / 横版），只看窗口朝向。
 *
 * 竖屏窗口必须用竖版：横版素材在竖屏被 cover 裁掉约 30%，而票面文字是印在素材上的
 * 叠加层，会跟着一起出画（朱印整枚不可见）；反过来横屏窗口用竖版素材会把标题顶出视口。
 * 见 src/lib/ticketLayout.ts 的 ticketArtKeyFor。
 *
 * 特意不跟 useViewportProfile 走：768×1024 属于 tablet 档却要竖版票版，
 * 568×320 属于 mobile 档却要横版——profile 管的是排版档位，不是"该用哪张纸"。
 */
export function useTicketArtwork(): "mobile" | "desktop" {
  const [artKey, setArtKey] = useState<"mobile" | "desktop">(read);

  useEffect(() => {
    const update = () => setArtKey(read());
    update();
    window.addEventListener("resize", update, { passive: true });
    window.addEventListener("orientationchange", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return artKey;
}
